import React from "react";
import styles from "./timezone-string-info-nav.module.scss";
import {
  ToolTip,
  ToolTipPositionType,
} from "@src/components/atoms/tooltip/tooltip";
import { useI18N, useLanguage } from "@src/language/language-context";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { getTimezoneDisplayName } from "@src/cloud-connect/utils/timezone-display-utils";

interface TimezoneStringInfoNavProps {
  tooltipPosition: ToolTipPositionType;
}

const cssClassName = "timezone-string-info-nav";

export const TimezoneStringInfoNav = ({
  tooltipPosition,
}: TimezoneStringInfoNavProps) => {
  const i18n = useI18N();
  const language = useLanguage();
  const timezone = useSelector((state: RootState) => state.yourSlice.timezone);

  const texts = {
    linkText: i18n("modules.timezoneStringInfo.linkText"),
    noneText: i18n("modules.timezoneStringInfo.noneText"),
    toolTipText: i18n("modules.timezoneStringInfo.toolTipText"),
  };

  const displayValue = timezone
    ? getTimezoneDisplayName(timezone, language)
    : texts.noneText;

  return (
    <div>
      <ToolTip content={texts.toolTipText} position={tooltipPosition}>
        <span
          className={styles[`${cssClassName}__link-text`]}
        >{`${texts.linkText}`}</span>
        <br />
        {`${displayValue}`}
      </ToolTip>
    </div>
  );
};
